import { ChangeDetectorRef, Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-missing-header',
  standalone: true,
  imports: [
    TranslocoModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './missing-header.component.html',
  styleUrl: './missing-header.component.scss'
})
export class MissingHeaderComponent implements OnInit, OnDestroy {
  data = inject(MAT_DIALOG_DATA);
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  lang: string = 'en';
  dialogRef: MatDialogRef<MissingHeaderComponent>;
  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _translocoService: TranslocoService,
  ) {

  }
  ngOnInit() {
    this._translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.lang = res;
      this._changeDetectorRef.markForCheck();
    })

  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
